import React from 'react';
import PropTypes from 'prop-types';

import Avatar from '../../Avatar';

const AdminReportsDataListItemUser = ({ item, inWidget }) => {
  const user = item.user || item;

  return (
    <th scope="row" className="user">
      {user.uuid ? (
        <a href={`/admin/users/${user.uuid}/edit`} target="_blank" rel="noopener noreferrer">
          <Avatar
            user={user}
            size={inWidget ? 30 : 40}
          />
          {user.name}
        </a>
      ) : (
        <>
          <Avatar
            user={user}
            size={inWidget ? 30 : 40}
          />
          {user.name}
        </>
      )}
    </th>
  );
};

AdminReportsDataListItemUser.propTypes = {
  item: PropTypes.object.isRequired,
  inWidget: PropTypes.bool.isRequired,
};

export default AdminReportsDataListItemUser;
